import React from "react";

interface PainelCardActionRowProps {
  children: React.ReactNode;
}

export const PainelCardActionRow: React.FC<PainelCardActionRowProps> = ({
  children,
}) => (
  <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-slate-100 pt-4">
    {children}
  </div>
);
